<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill="currentColor" d="M8 13v-1.5h8V13zm0-4.25v-1.5h6v1.5zM8 4.5V3h4v1.5z"/><path fill="currentColor" d="M4 3v4h3l-3.5 6L0 7h3V3z"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-sort-down',
});
</script>
